<template>
  <footer class="footer">
    <div class="footer__top">
      <div class="wrapper">
        <div class="footer__top--left">
          <router-link to="/impressum" class="">Impressum</router-link>
          <router-link to="/datenschutz">Datenschutz</router-link>
          <a href="mailto:bodycontact@heartshaped.de">Kontakt</a>
        </div>
        <div class="footer__top--right">
          <a href=""><img src="../../assets/images/social-facebook.svg"></a>
          <a href=""><img src="../../assets/images/social-insta.svg"></a>
          <a href=""><img src="../../assets/images/social-twitter.svg"></a>
        </div>
      </div>
    </div>
    <div class="footer__content">
      <div class="wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-4 col-md-3 hide-mobile">
            <h5>Aktuelles</h5>
            <div class="greenline" />
            <ul>
              <li><a href="">Aktuelles aus der Stadt</a></li>
              <li><a href="">Öffentlichkeitsbeteiligung</a></li>
              <li><a href="">Stellenanzeigen</a></li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-3 hide-mobile">
            <h5>Kommunikation</h5>
            <div class="greenline" />
            <ul>
              <li><a href="">Presse & Kommunikation</a></li>
              <li><a href="">Informationssatzung</a></li>
              <li><a href="">Amtliche Bekanntmachungen</a></li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-3">
            <h5>Kontakt</h5>
            <div class="greenline" />
            <ul>
              <li>Stadt Augsburg – E-Government</li>
              <li>An der Blauen Kappe 18</li>
              <li>86152 Augsburg</li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-3 hide-mobile">
            <ul class="margin-top--50">
              <li>0821 324-2645</li>
              <li>e-government@augsburg.de</li>
              <li><a href="">Anfahrt anzeigen</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <div class="wrapper">
        © Bürgerservice-Portal Augsburg – 2019
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Footer.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue